(function () {
  function showCartNotice(message, tone) {
    const existing = document.querySelector('[data-kartolog-cart-notice]');
    if (existing) existing.remove();

    const notice = document.createElement('div');
    notice.setAttribute('data-kartolog-cart-notice', 'true');
    notice.setAttribute('role', 'status');
    notice.textContent = message;
    Object.assign(notice.style, {
      position: 'fixed',
      left: '50%',
      bottom: '22px',
      zIndex: '2147483647',
      transform: 'translateX(-50%)',
      padding: '12px 18px',
      borderRadius: '0',
      background: tone === 'success' ? 'linear-gradient(135deg, #18b7a4, #8bd64f)' : 'linear-gradient(135deg, #ff3b4f, #ff8a00)',
      color: '#fff',
      fontFamily: 'Jost, sans-serif',
      fontSize: '15px',
      fontWeight: '500',
      letterSpacing: '0',
      boxShadow: '0 14px 34px rgba(18, 24, 38, 0.18)',
      pointerEvents: 'none',
      opacity: '0',
      transition: 'opacity 180ms ease, transform 180ms ease',
    });

    document.body.appendChild(notice);
    requestAnimationFrame(() => {
      notice.style.opacity = '1';
      notice.style.transform = 'translateX(-50%) translateY(-4px)';
    });

    window.setTimeout(() => {
      notice.style.opacity = '0';
      notice.style.transform = 'translateX(-50%) translateY(4px)';
      window.setTimeout(() => notice.remove(), 220);
    }, 2600);
  }

  function shouldSuppressCartOpen() {
    return Date.now() < Number(window.__kartologSuppressCartOpenUntil || 0);
  }

  function suppressCartOpen() {
    window.__kartologSuppressCartOpenUntil = Date.now() + 5000;
  }

  function patchCartElement(tagName) {
    if (!window.customElements?.whenDefined) return;

    window.customElements
      .whenDefined(tagName)
      .then(() => {
        const ElementClass = window.customElements.get(tagName);
        const prototype = ElementClass?.prototype;
        if (!prototype || prototype.__kartologCartOpenPatched) return;

        const originalOpen = prototype.open;
        if (typeof originalOpen === 'function') {
          prototype.open = function patchedOpen() {
            if (shouldSuppressCartOpen()) return;
            return originalOpen.apply(this, arguments);
          };
        }

        prototype.__kartologCartOpenPatched = true;
      })
      .catch(() => {});
  }

  patchCartElement('cart-drawer');
  patchCartElement('cart-notification');

  function isCartAddRequest(resource, options) {
    const method = String(options?.method || resource?.method || 'GET').toUpperCase();
    const url = String(resource?.url || resource || '');
    return method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function isStockError(payload) {
    const text = String(payload?.description || payload?.message || payload?.error || '').toLowerCase();
    return (
      payload?.status === 422 ||
      text.includes('sold out') ||
      text.includes('out of stock') ||
      text.includes('not enough') ||
      text.includes("can't add more") ||
      text.includes('stok') ||
      text.includes('tükendi') ||
      text.includes('tÃ¼kendi')
    );
  }

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function' && !window.__kartologStockNoticeFetchReady) {
    window.__kartologStockNoticeFetchReady = true;
    window.fetch = async function kartologFetch(resource, options) {
      const isCartAdd = isCartAddRequest(resource, options);
      if (isCartAdd) suppressCartOpen();

      const response = await nativeFetch.apply(this, arguments);

      if (isCartAdd && response.ok) {
        showCartNotice('Sepete eklendi.', 'success');
      }

      if (isCartAdd && !response.ok) {
        response
          .clone()
          .json()
          .then((payload) => {
            if (isStockError(payload)) showCartNotice('Stok bulunmuyor.', 'error');
          })
          .catch(() => showCartNotice('Stok bulunmuyor.', 'error'));
      }

      return response;
    };
  }

  const sectionSelector = [
    '[id$="__featured_collection_zVppNp"]',
    '[id$="__kartolog_home_accessories"]',
    '[id$="__kartolog_home_sealed"]',
    '[id$="__kartolog_home_set_1"]',
    '[id$="__kartolog_home_set_2"]',
    '[id$="__kartolog_home_set_3"]',
    '[id$="__kartolog_home_bulk"]',
    '[id$="__kartolog_home_popular_products"]',
    '[id$="__kartolog_home_cart_pending"]',
    '[id$="__kartolog_home_valuable_cards"]',
    '[id$="__kartolog_home_other_cards"]',
  ].join(',');

  let startX = 0;
  let startY = 0;
  let moved = false;

  document.addEventListener(
    'mousedown',
    (event) => {
      if (event.button !== 0) return;
      if (!event.target.closest(sectionSelector)) return;
      startX = event.clientX;
      startY = event.clientY;
      moved = false;
    },
    true,
  );

  document.addEventListener(
    'mousemove',
    (event) => {
      if (Math.abs(event.clientX - startX) > 7 || Math.abs(event.clientY - startY) > 7) {
        moved = true;
      }
    },
    true,
  );

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const section = event.target.closest(sectionSelector);
      if (!section || moved) return;

      const link = event.target.closest('a[href]');
      if (!link || !section.contains(link) || link.closest('.kartolog-slider-nav')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(link.href);
    },
    true,
  );
})();
